export default __webpack_public_path__ + "static/media/icon-facebook.70785e59.svg";